import { css } from 'styled-components';
import BarlowFontFaces from './Barlow';
import GilroyFontFaces from './Gilroy';
import BarlowCondensedFontFaces from './BarlowCondensed';
import BarlowSemiCondensedFontFaces from './BarlowSemiCondensed';
import PrimaryFontFaces from './Primary';
import SecondaryFontFaces from './Secondary';
import IconsFontFace from './Icons';
export const FontFaces = css `
    ${BarlowFontFaces}
    ${GilroyFontFaces}
    ${BarlowCondensedFontFaces}
    ${BarlowSemiCondensedFontFaces}
    ${PrimaryFontFaces}
    ${SecondaryFontFaces}
    ${IconsFontFace}
`;
//# sourceMappingURL=index.js.map